import mermaid from 'mermaid';

let isInitialized = false;

export function initializeMermaid() {
    if (isInitialized) return;
    
    mermaid.initialize({
        startOnLoad: false,
        theme: 'default',
        securityLevel: 'loose',
        maxTextSize: 50000
    });
    
    isInitialized = true;
}

export async function renderMermaidDiagram(code: string): Promise<string> {
    if (!isInitialized) {
        initializeMermaid();
    }
    
    try {
        const id = `mermaid-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        const { svg } = await mermaid.render(id, code);
        return svg;
    } catch (error) {
        console.warn('Failed to render mermaid diagram:', error);
        return `<pre class="mermaid-error" style="border: 1px solid red; background: #ffeeee; padding: 10px;">Mermaid Error: ${(error as Error).message}<br><code>${code}</code></pre>`;
    }
}

export async function renderMermaidInContainer(container: ParentNode): Promise<void> {
    const mermaidBlocks = container.querySelectorAll('pre > code.language-mermaid');
    
    if (mermaidBlocks.length === 0) {
        return;
    }
    
    const renderPromises = Array.from(mermaidBlocks).map(async (codeElement) => {
        const code = codeElement.textContent || '';
        const pre = codeElement.parentElement;
        if (!pre) return;
        
        try {
            const svg = await renderMermaidDiagram(code);
            
            const wrapper = document.createElement('div');
            wrapper.className = 'mermaid-diagram';
            wrapper.innerHTML = svg;
            
            pre.parentNode?.replaceChild(wrapper, pre);
        } catch (error) {
            console.error('Failed to render mermaid block:', error);
        }
    });
    
    await Promise.all(renderPromises);
}

export async function renderMermaidInHtml(html: string): Promise<string> {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    await renderMermaidInContainer(doc.body);
    
    return doc.body.innerHTML;
}